import React, { useState } from 'react';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';

const hotelCategories = [
  { icon: '👑', label: 'Luxury Hotels' },
  { icon: '💼', label: 'Business Hotels' },
  { icon: '🌿', label: 'Resorts' },
  { icon: '🏛', label: 'Heritage Hotels' },
  { icon: '🏖', label: 'Beach Resorts' },
  { icon: '👨‍👩‍👧‍👦', label: 'Family Hotels' },
  { icon: '💎', label: 'Boutique Hotels' },
];

const hotels = [
  {
    name: 'The Leela Palace',
    city: 'Udaipur',
    rating: 5,
    reviews: 1284,
    img: 'https://images.unsplash.com/photo-1715405155683-e36aff15fd53?w=600&h=380&fit=crop&auto=format',
    price: '₹18,500',
    discount: '15% off',
    amenities: ['Pool', 'Spa', 'Restaurant', 'Wi-Fi', 'Airport Transfer'],
    tag: 'Luxury',
    tagColor: '#C9A45C',
    freeCancel: true,
    breakfast: true,
  },
  {
    name: 'ITC Grand Bharat',
    city: 'Gurugram, Delhi NCR',
    rating: 5,
    reviews: 876,
    img: 'https://images.unsplash.com/photo-1669040186487-ad7a6d6d0004?w=600&h=380&fit=crop&auto=format',
    price: '₹22,000',
    discount: '10% off',
    amenities: ['Golf Course', 'Spa', '5 Restaurants', 'Wi-Fi', 'Concierge'],
    tag: 'Heritage Luxury',
    tagColor: '#0D233A',
    freeCancel: true,
    breakfast: true,
  },
  {
    name: 'Taj Exotica',
    city: 'Goa',
    rating: 5,
    reviews: 2140,
    img: 'https://images.unsplash.com/photo-1593417033942-bcdf26b74700?w=600&h=380&fit=crop&auto=format',
    price: '₹14,200',
    discount: '20% off',
    amenities: ['Beach Access', 'Pool', 'Spa', 'Multiple Restaurants', 'Wi-Fi'],
    tag: 'Beach Resort',
    tagColor: '#16865B',
    freeCancel: false,
    breakfast: true,
  },
  {
    name: 'Vivanta Srinagar',
    city: 'Srinagar, Kashmir',
    rating: 4,
    reviews: 643,
    img: 'https://images.unsplash.com/photo-1614591276564-7b3e69347a48?w=600&h=380&fit=crop&auto=format',
    price: '₹9,800',
    discount: '12% off',
    amenities: ['Lake View', 'Restaurant', 'Shikara', 'Wi-Fi'],
    tag: 'Trending',
    tagColor: '#718096',
    freeCancel: true,
    breakfast: false,
  },
];

const destinationCities = [
  { name: 'Goa', desc: 'Beach Paradise', img: 'https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=300&h=200&fit=crop&auto=format' },
  { name: 'Mumbai', desc: 'City of Dreams', img: 'https://images.unsplash.com/photo-1715457573748-8e8a70b2c1be?w=300&h=200&fit=crop&auto=format' },
  { name: 'Udaipur', desc: 'City of Lakes', img: 'https://images.unsplash.com/photo-1695956353120-54ce5e91632b?w=300&h=200&fit=crop&auto=format' },
  { name: 'Kerala', desc: "God's Own Country", img: 'https://images.unsplash.com/photo-1506461883276-594a12b11cf3?w=300&h=200&fit=crop&auto=format' },
];

export default function Hotels() {
  const [searched, setSearched] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [activeCategory, setActiveCategory] = useState(0);

  const btnGoldStyle = {
    background: 'var(--gold, #C9A45C)',
    color: 'var(--navy, #071A2B)',
    fontWeight: 700,
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'Manrope, sans-serif',
  };

  const sectionLabelStyle = {
    textTransform: 'uppercase',
    letterSpacing: '0.12em',
    fontSize: '12px',
    fontWeight: 700,
    color: 'var(--gold, #C9A45C)',
    fontFamily: 'Manrope, sans-serif',
  };

  const formInputStyle = {
    width: '100%',
    padding: '10px 12px',
    borderRadius: '8px',
    fontSize: '13px',
    outline: 'none',
    background: 'rgba(255, 255, 255, 0.12)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    color: '#ffffff',
    boxSizing: 'border-box',
    fontFamily: 'Manrope, sans-serif',
  };

  const formLabelStyle = {
    display: 'block',
    fontSize: '10px',
    fontWeight: 700,
    marginBottom: '4px',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: 'rgba(255, 255, 255, 0.5)',
    fontFamily: 'Manrope, sans-serif',
  };

  return (
    <>
      <div style={{ minHeight: '100vh', background: 'var(--bg, #F8FAFC)', fontFamily: 'Manrope, sans-serif', }}>
        {/* Hero */}
        <div style={{ background: 'var(--navy, #071A2B)', paddingTop: '80px', paddingBottom: '48px', position: 'relative', overflow: 'hidden', }}>
          <img src="https://images.unsplash.com/photo-1715405155683-e36aff15fd53?w=1600&h=400&fit=crop&auto=format" alt="Luxury hotel" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.3, }} />
          <div style={{ position: 'relative', zIndex: 10, maxWidth: '1280px', margin: '0 auto', padding: '32px 24px', textAlign: 'center', boxSizing: 'border-box', }}>
            <p style={{ ...sectionLabelStyle, marginBottom: '12px' }}>Hotels & Resorts</p>
            <h1
              style={{
                fontSize: 'clamp(2.5rem, 5vw, 3rem)',
                fontWeight: 800,
                color: '#ffffff',
                marginBottom: '16px',
                fontFamily: 'Manrope, sans-serif',
                margin: '0 0 16px 0',
              }}
            >
              Stay Somewhere Exceptional.
            </h1>
            <p
              style={{
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '15px',
                marginBottom: '32px',
                margin: '0 0 32px 0',
              }}
            >
              Handpicked hotels across India — from boutique retreats to 5-star landmarks.
            </p>

            {/* Search Form */}
            <div
              style={{
                maxWidth: '768px',
                margin: '0 auto',
                borderRadius: '16px',
                padding: '16px',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.15)',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                boxSizing: 'border-box',
              }}
            >
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))',
                  gap: '12px',
                }}
              >
                <div>
                  <label style={formLabelStyle}>City</label>
                  <select style={formInputStyle}>
                    <option style={{ color: '#000' }}>Goa</option>
                    <option style={{ color: '#000' }}>Mumbai</option>
                    <option style={{ color: '#000' }}>Delhi</option>
                    <option style={{ color: '#000' }}>Udaipur</option>
                    <option style={{ color: '#000' }}>Jaipur</option>
                    <option style={{ color: '#000' }}>Srinagar</option>
                  </select>
                </div>
                <div>
                  <label style={formLabelStyle}>Check-in</label>
                  <input type="date" defaultValue="2026-09-15" style={formInputStyle} />
                </div>
                <div>
                  <label style={formLabelStyle}>Check-out</label>
                  <input type="date" defaultValue="2026-09-18" style={formInputStyle} />
                </div>
                <div>
                  <label style={formLabelStyle}>Guests & Rooms</label>
                  <select style={formInputStyle}>
                    <option style={{ color: '#000' }}>2 Adults · 1 Room</option>
                    <option style={{ color: '#000' }}>1 Adult · 1 Room</option>
                    <option style={{ color: '#000' }}>4 Adults · 2 Rooms</option>
                  </select>
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                  <button
                    type="button"
                    onClick={() => setSearched(true)}
                    style={{
                      ...btnGoldStyle,
                      width: '100%',
                      padding: '10px 0',
                      borderRadius: '8px',
                      fontSize: '13px',
                    }}
                  >
                    Search Hotels
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {!searched ? (
          /* Destination Tiles Section */
          <div
            style={{
              maxWidth: '1280px',
              margin: '0 auto',
              padding: '48px 24px',
              boxSizing: 'border-box',
            }}
          >
            <p style={{ ...sectionLabelStyle, marginBottom: '12px' }}>Popular Cities</p>
            <h2
              style={{
                fontSize: '30px',
                fontWeight: 800,
                marginBottom: '32px',
                fontFamily: 'Manrope, sans-serif',
                color: 'var(--navy, #071A2B)',
                margin: '0 0 32px 0',
              }}
            >
              Where Would You Like to Stay?
            </h2>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                gap: '16px',
                marginBottom: '40px',
              }}
            >
              {destinationCities.map((city) => (
                <div
                  key={city.name}
                  onClick={() => setSearched(true)}
                  style={{
                    borderRadius: '12px',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    border: '1px solid var(--border, rgba(7, 26, 43, 0.08))',
                    position: 'relative',
                  }}
                >
                  <div style={{ position: 'relative', height: '160px', backgroundColor: '#E2E8F0' }}>
                    <img
                      src={city.img}
                      alt={city.name}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                    <div
                      style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'linear-gradient(to top, rgba(7,26,43,0.7) 0%, transparent 50%)',
                      }}
                    />
                    <div style={{ position: 'absolute', bottom: '12px', left: '12px' }}>
                      <p
                        style={{
                          color: '#ffffff',
                          fontWeight: 700,
                          fontSize: '15px',
                          fontFamily: 'Manrope, sans-serif',
                          margin: 0,
                        }}
                      >
                        {city.name}
                      </p>
                      <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '12px', margin: '2px 0 0 0' }}>
                        {city.desc}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Categories */}
            <div
              style={{
                display: 'flex',
                gap: '12px',
                overflowX: 'auto',
                paddingBottom: '8px',
                marginBottom: '32px',
              }}
            >
              {hotelCategories.map((cat, i) => (
                <button
                  key={cat.label}
                  type="button"
                  onClick={() => setActiveCategory(i)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 16px',
                    borderRadius: '9999px',
                    fontSize: '13px',
                    fontWeight: 600,
                    flexShrink: 0,
                    cursor: 'pointer',
                    background: activeCategory === i ? 'var(--navy, #071A2B)' : '#ffffff',
                    color: activeCategory === i ? '#ffffff' : 'var(--text-secondary, #4A5568)',
                    border: `1px solid ${activeCategory === i ? 'var(--navy, #071A2B)' : 'var(--border, rgba(7, 26, 43, 0.08))'}`,
                    fontFamily: 'Manrope, sans-serif',
                  }}
                >
                  {cat.icon} {cat.label}
                </button>
              ))}
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(360px, 1fr))',
                gap: '20px',
              }}
            >
              {hotels.map((h, i) => (
                <HotelCard
                  key={h.name}
                  hotel={h}
                  onSelect={() => setSelectedHotel(i)}
                  selected={selectedHotel === i}
                />
              ))}
            </div>
          </div>
        ) : (
          /* Results View */
          <div
            style={{
              maxWidth: '1280px',
              margin: '0 auto',
              padding: '32px 24px',
              boxSizing: 'border-box',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '16px',
              }}
            >
              <div>
                <h2
                  style={{
                    fontSize: '20px',
                    fontWeight: 700,
                    fontFamily: 'Manrope, sans-serif',
                    color: 'var(--navy, #071A2B)',
                    margin: 0,
                  }}
                >
                  Hotels in Goa · 15–18 Sep · 2 Adults
                </h2>
                <p style={{ fontSize: '13px', color: 'var(--text-muted, #718096)', margin: '4px 0 0 0' }}>
                  {hotels.length} properties found
                </p>
              </div>
              <button
                type="button"
                onClick={() => setSearched(false)}
                style={{
                  fontSize: '13px',
                  fontWeight: 500,
                  padding: '6px 12px',
                  borderRadius: '8px',
                  background: 'transparent',
                  border: '1px solid var(--border, rgba(7, 26, 43, 0.12))',
                  color: 'var(--text-secondary, #4A5568)',
                  fontFamily: 'Manrope, sans-serif',
                  cursor: 'pointer',
                }}
              >
                ← Modify Search
              </button>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
                gap: '20px',
              }}
            >
              {/* Filters Sidebar */}
              <div style={{ minWidth: '240px' }}>
                <div
                  style={{
                    borderRadius: '12px',
                    padding: '20px',
                    background: '#ffffff',
                    border: '1px solid var(--border, rgba(7, 26, 43, 0.08))',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                    position: 'sticky',
                    top: '80px',
                  }}
                >
                  <h3
                    style={{
                      fontWeight: 700,
                      fontSize: '14px',
                      marginBottom: '16px',
                      fontFamily: 'Manrope, sans-serif',
                      color: 'var(--navy, #071A2B)',
                      margin: '0 0 16px 0',
                    }}
                  >
                    Filters
                  </h3>
                  {[
                    { label: 'Star Rating', options: ['5 Star', '4 Star', '3 Star'] },
                    { label: 'Property Type', options: ['Hotels', 'Resorts', 'Boutique', 'Heritage'] },
                    { label: 'Amenities', options: ['Pool', 'Spa', 'Breakfast Included', 'Free Cancellation', 'Wi-Fi'] },
                  ].map((group) => (
                    <div key={group.label} style={{ marginBottom: '20px' }}>
                      <p
                        style={{
                          fontSize: '12px',
                          fontWeight: 700,
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                          marginBottom: '8px',
                          color: 'var(--text-muted, #718096)',
                          fontFamily: 'Manrope, sans-serif',
                          margin: '0 0 8px 0',
                        }}
                      >
                        {group.label}
                      </p>
                      {group.options.map((opt) => (
                        <label
                          key={opt}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            marginBottom: '8px',
                            cursor: 'pointer',
                          }}
                        >
                          <input type="checkbox" style={{ width: '14px', height: '14px' }} />
                          <span style={{ fontSize: '13px', color: 'var(--text-secondary, #4A5568)' }}>
                            {opt}
                          </span>
                        </label>
                      ))}
                    </div>
                  ))}
                  <div style={{ marginBottom: '16px' }}>
                    <p
                      style={{
                        fontSize: '12px',
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        marginBottom: '8px',
                        color: 'var(--text-muted, #718096)',
                        fontFamily: 'Manrope, sans-serif',
                        margin: '0 0 8px 0',
                      }}
                    >
                      Price Per Night
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        fontSize: '12px',
                        marginBottom: '4px',
                        color: 'var(--text-muted, #718096)',
                      }}
                    >
                      <span>₹5,000</span>
                      <span>₹50,000</span>
                    </div>
                    <input
                      type="range"
                      min={5000}
                      max={50000}
                      defaultValue={25000}
                      style={{ width: '100%' }}
                    />
                  </div>
                  <button
                    type="button"
                    style={{
                      ...btnGoldStyle,
                      width: '100%',
                      padding: '8px 0',
                      borderRadius: '8px',
                      fontSize: '13px',
                    }}
                  >
                    Apply
                  </button>
                </div>
              </div>

              {/* Results List */}
              <div
                style={{
                  gridColumn: 'span 2',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                }}
              >
                {hotels.map((h, i) => (
                  <HotelCard
                    key={h.name}
                    hotel={h}
                    onSelect={() => setSelectedHotel(i)}
                    selected={selectedHotel === i}
                  />
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Hotel Detail Modal */}
        {selectedHotel !== null && (
          <div
            style={{
              position: 'fixed',
              inset: 0,
              zIndex: 50,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '16px',
              background: 'rgba(7, 26, 43, 0.8)',
              boxSizing: 'border-box',
            }}
          >
            <div
              style={{
                width: '100%',
                maxWidth: '672px',
                maxHeight: '90vh',
                overflowY: 'auto',
                borderRadius: '16px',
                background: '#ffffff',
                position: 'relative',
              }}
            >
              <div style={{ position: 'relative', height: '192px', backgroundColor: '#E2E8F0' }}>
                <img
                  src={hotels[selectedHotel].img}
                  alt={hotels[selectedHotel].name}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                <button
                  type="button"
                  onClick={() => setSelectedHotel(null)}
                  style={{
                    position: 'absolute',
                    top: '16px',
                    right: '16px',
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#ffffff',
                    fontWeight: 700,
                    fontSize: '18px',
                    background: 'rgba(7, 26, 43, 0.6)',
                    border: 'none',
                    cursor: 'pointer',
                  }}
                >
                  ×
                </button>
              </div>
              <div style={{ padding: '20px' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    marginBottom: '16px',
                  }}
                >
                  <div>
                    <h2
                      style={{
                        fontSize: '20px',
                        fontWeight: 800,
                        fontFamily: 'Manrope, sans-serif',
                        color: 'var(--navy, #071A2B)',
                        margin: 0,
                      }}
                    >
                      {hotels[selectedHotel].name}
                    </h2>
                    <p
                      style={{
                        fontSize: '13px',
                        color: 'var(--text-muted, #718096)',
                        margin: '2px 0 0 0',
                      }}
                    >
                      {hotels[selectedHotel].city}
                    </p>
                    <div style={{ display: 'flex', gap: '2px', marginTop: '4px' }}>
                      {Array.from({ length: hotels[selectedHotel].rating }).map((_, j) => (
                        <span key={j} style={{ color: 'var(--gold, #C9A45C)' }}>★</span>
                      ))}
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <p
                      style={{
                        fontSize: '24px',
                        fontWeight: 800,
                        fontFamily: 'Manrope, sans-serif',
                        color: 'var(--navy, #071A2B)',
                        margin: 0,
                      }}
                    >
                      {hotels[selectedHotel].price}
                    </p>
                    <p style={{ fontSize: '12px', color: 'var(--text-muted, #718096)', margin: 0 }}>
                      per night
                    </p>
                  </div>
                </div>

                {/* Room options */}
                <h3
                  style={{
                    fontWeight: 700,
                    fontSize: '14px',
                    marginBottom: '12px',
                    fontFamily: 'Manrope, sans-serif',
                    color: 'var(--navy, #071A2B)',
                    margin: '0 0 12px 0',
                  }}
                >
                  Available Rooms
                </h3>
                {[
                  {
                    room: 'Deluxe Room',
                    bed: 'King Bed',
                    price: hotels[selectedHotel].price,
                    features: ['Breakfast Included', 'Free Cancellation', 'City View'],
                  },
                  {
                    room: 'Superior Room',
                    bed: 'Twin Beds',
                    price: `₹${(parseInt(hotels[selectedHotel].price.replace(/[₹,]/g, '')) + 2000).toLocaleString('en-IN')}`,
                    features: ['Room Only', 'Free Cancellation', 'Garden View'],
                  },
                  {
                    room: 'Suite',
                    bed: 'King Bed',
                    price: `₹${(parseInt(hotels[selectedHotel].price.replace(/[₹,]/g, '')) + 8000).toLocaleString('en-IN')}`,
                    features: ['Breakfast + Dinner', 'Free Cancellation', 'Ocean View', 'Butler Service'],
                  },
                ].map((room) => (
                  <div
                    key={room.room}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '16px',
                      borderRadius: '12px',
                      marginBottom: '12px',
                      border: '1px solid var(--border, rgba(7, 26, 43, 0.08))',
                      background: 'var(--bg, #F8FAFC)',
                    }}
                  >
                    <div>
                      <p
                        style={{
                          fontWeight: 700,
                          fontSize: '14px',
                          fontFamily: 'Manrope, sans-serif',
                          color: 'var(--navy, #071A2B)',
                          margin: 0,
                        }}
                      >
                        {room.room}
                      </p>
                      <p
                        style={{
                          fontSize: '12px',
                          marginBottom: '6px',
                          color: 'var(--text-muted, #718096)',
                          margin: '2px 0 6px 0',
                        }}
                      >
                        {room.bed}
                      </p>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                        {room.features.map((f) => (
                          <span
                            key={f}
                            style={{
                              fontSize: '10px',
                              padding: '2px 6px',
                              borderRadius: '4px',
                              background: 'rgba(201, 164, 92, 0.1)',
                              color: '#9C782E',
                              fontFamily: 'Manrope, sans-serif',
                            }}
                          >
                            ✓ {f}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div style={{ textAlign: 'right', marginLeft: '16px' }}>
                      <p
                        style={{
                          fontWeight: 800,
                          fontSize: '16px',
                          fontFamily: 'Manrope, sans-serif',
                          color: 'var(--navy, #071A2B)',
                          margin: 0,
                        }}
                      >
                        ₹{parseInt(room.price.replace(/[₹,]/g, '')).toLocaleString('en-IN')}
                      </p>
                      <p
                        style={{
                          fontSize: '11px',
                          marginBottom: '8px',
                          color: 'var(--text-muted, #718096)',
                          margin: '2px 0 8px 0',
                        }}
                      >
                        per night
                      </p>
                      <button
                        type="button"
                        style={{
                          ...btnGoldStyle,
                          padding: '6px 16px',
                          borderRadius: '8px',
                          fontSize: '12px',
                        }}
                      >
                        Select Room
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}

function HotelCard({ hotel, onSelect, selected }) {
  const btnGoldStyle = {
    background: 'var(--gold, #C9A45C)',
    color: 'var(--navy, #071A2B)',
    fontWeight: 700,
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'Manrope, sans-serif',
  };

  return (
    <>
      <Nav />
      <div
        onClick={onSelect}
        style={{
          borderRadius: '12px',
          overflow: 'hidden',
          cursor: 'pointer',
          background: '#ffffff',
          border: selected
            ? '1.5px solid var(--royal, #0D233A)'
            : '1px solid var(--border, rgba(7, 26, 43, 0.08))',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', }}>
          <div
            style={{
              position: 'relative',
              width: '192px',
              minHeight: '176px',
              backgroundColor: '#E2E8F0',
              flexShrink: 0,
            }}
          >
            <img
              src={hotel.img}
              alt={hotel.name}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
            <span
              style={{
                position: 'absolute',
                top: '8px',
                left: '8px',
                fontSize: '10px',
                fontWeight: 700,
                padding: '2px 8px',
                borderRadius: '9999px',
                color: '#ffffff',
                background: hotel.tagColor,
                fontFamily: 'Manrope, sans-serif',
              }}
            >
              {hotel.tag}
            </span>
            {hotel.discount && (
              <span
                style={{
                  position: 'absolute',
                  bottom: '8px',
                  left: '8px',
                  fontSize: '10px',
                  fontWeight: 700,
                  padding: '2px 8px',
                  borderRadius: '4px',
                  color: '#ffffff',
                  background: '#E53E3E',
                  fontFamily: 'Manrope, sans-serif',
                }}
              >
                {hotel.discount}
              </span>
            )}
          </div>
          <div
            style={{
              padding: '16px',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              minWidth: '220px',
            }}
          >
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                }}
              >
                <div>
                  <h3
                    style={{
                      fontWeight: 800,
                      fontSize: '15px',
                      fontFamily: 'Manrope, sans-serif',
                      color: 'var(--navy, #071A2B)',
                      margin: 0,
                    }}
                  >
                    {hotel.name}
                  </h3>
                  <p
                    style={{
                      fontSize: '12px',
                      color: 'var(--text-muted, #718096)',
                      margin: '2px 0 0 0',
                    }}
                  >
                    📍 {hotel.city}
                  </p>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <p
                    style={{
                      fontWeight: 800,
                      fontSize: '17px',
                      fontFamily: 'Manrope, sans-serif',
                      color: 'var(--navy, #071A2B)',
                      margin: 0,
                    }}
                  >
                    {hotel.price}
                  </p>
                  <p style={{ fontSize: '11px', color: 'var(--text-muted, #718096)', margin: 0 }}>
                    per night
                  </p>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  marginTop: '4px',
                  marginBottom: '8px',
                }}
              >
                {Array.from({ length: hotel.rating }).map((_, i) => (
                  <span key={i} style={{ fontSize: '12px', color: 'var(--gold, #C9A45C)' }}>★</span>
                ))}
                <span
                  style={{
                    fontSize: '12px',
                    marginLeft: '4px',
                    color: 'var(--text-muted, #718096)',
                  }}
                >
                  ({hotel.reviews.toLocaleString()} reviews)
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '6px',
                  marginBottom: '12px',
                }}
              >
                {hotel.amenities.slice(0, 4).map((a) => (
                  <span
                    key={a}
                    style={{
                      fontSize: '11px',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      background: 'var(--bg, #F8FAFC)',
                      border: '1px solid var(--border, rgba(7, 26, 43, 0.08))',
                      color: 'var(--text-secondary, #4A5568)',
                    }}
                  >
                    {a}
                  </span>
                ))}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ display: 'flex', gap: '8px' }}>
                {hotel.breakfast && (
                  <span
                    style={{
                      fontSize: '11px',
                      fontWeight: 600,
                      color: '#38A169',
                      fontFamily: 'Manrope, sans-serif',
                    }}
                  >
                    ✓ Breakfast
                  </span>
                )}
                {hotel.freeCancel && (
                  <span
                    style={{
                      fontSize: '11px',
                      fontWeight: 600,
                      color: '#38A169',
                      fontFamily: 'Manrope, sans-serif',
                    }}
                  >
                    ✓ Free Cancellation
                  </span>
                )}
              </div>
              <button
                type="button"
                onClick={onSelect}
                style={{
                  ...btnGoldStyle,
                  padding: '8px 16px',
                  borderRadius: '8px',
                  fontSize: '12px',
                }}
              >
                View Hotel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}